import React, { Component } from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, SelectInput, TextInput } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import PropertyGroups from '../../../Common/Partials/PropertyGroups/PropertyGroups';
import SlotPositionChoices from '../StaticData/SlotPositionChoices';
import SlotTypeChoices from '../StaticData/SlotTypeChoices';

const styles = createStyles({
  longFields: {
    width: '90%'
  },
  shortFields: {
    width: '40%'
  }
});

const ValidateRequired = required();

type Props = {
  classes: any,
  expand: boolean,
  handleRemove: any,
  item: string,
  propertyGroupOptions: string[],
  record: any,
  slotIndex: number
};

class SlotBody extends Component<Props> {
  handleRemove = (event, index) => {
    this.props.handleRemove(event, index)
  }

  handlePropertyGroupsRemove = (event, index) => {
    this.props.record.slots[this.props.slotIndex].property_groups.splice(index, 1);
    this.setState({ propertyGroupRecords: this.props.record.slots[this.props.slotIndex].property_groups });
  }

  render() {
    const propertyGroupRecords = this.props.record && this.props.record.slots && this.props.record.slots[this.props.slotIndex] ? this.props.record.slots[this.props.slotIndex].property_groups : [];

    return (
      <div style={{ display: this.props.expand ? 'initial' : 'none' }}>
        <div style={{ padding: 20 }}>
          <Field
            component={TextInput} label="Name *"
            className={this.props.classes.longFields}
            name={`${this.props.item}.name`}
            source={`${this.props.item}.name`}
            validate={ValidateRequired} /><br />

          <Field
            className={this.props.classes.shortFields}
            component={TextInput} label="Hook *"
            name={`${this.props.item}.hook`}
            source={`${this.props.item}.hook`}
            validate={ValidateRequired} /><br />

          <Field
            choices={SlotTypeChoices}
            className={this.props.classes.shortFields}
            component={SelectInput}
            label="Type *"
            name={`${this.props.item}.type`}
            source={`${this.props.item}.type`}
            validate={ValidateRequired} /><br />

          <Field
            choices={SlotPositionChoices}
            className={this.props.classes.shortFields}
            component={SelectInput}
            label="Position *"
            name={`${this.props.item}.position`}
            source={`${this.props.item}.position`}
            validate={ValidateRequired} /><br /><br />

          <Field
            className={this.props.classes.shortFields}
            component={BooleanInput}
            label="Reserved"
            name={`${this.props.item}.reserved`}
            source={`${this.props.item}.reserved`} />

          <div style={{ display: 'flex', width: '40%' }}>
            <div style={{ flex: 1 }}>
              <Field
                className={this.props.classes.longFields}
                component={TextInput}
                label="Width"
                name={`${this.props.item}.size.width`}
                source={`${this.props.item}.size.width`} /><br />
            </div>
            <div style={{ flex: 1 }}>
              <Field
                className={this.props.classes.longFields}
                component={TextInput}
                label="Height"
                name={`${this.props.item}.size.height`}
                source={`${this.props.item}.size.height`} /><br />
            </div>
          </div><br />

          <div>
            <FieldArray
              addItemLabel="Add Property Groups"
              component={PropertyGroups}
              handlePropertyGroupsRemove={this.handlePropertyGroupsRemove}
              mainLabel="Property Groups"
              name={`${this.props.item}.property_groups`}
              propertyGroupOptions={this.props.propertyGroupOptions}
              propertyGroupRecords={propertyGroupRecords}
              record={this.props.record} /><br />
          </div>
        </div>
      </div>
    );
  }
};

export default withStyles(styles)(SlotBody);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/SlotBody.tsx